import styles from "./premarket.module.css"
import { formatDate } from "@utils/time"

const Footer = ({ timestamp }: { timestamp: string }) => {
  const formattedDate = formatDate(timestamp)
  return (
    <footer className={styles.footer}>
      <p>
        Index is calculated by Julius Baer based on mid prices. Premarket data may not be delivered to any other
        professional Information Supplier Provider without prior approval by Julius Baer.
      </p>
      <p>
        Last updated
        <span style={{ marginLeft: "5px" }}>{formattedDate}</span>
      </p>
    </footer>
  )
}

export default Footer
